import { ACR, BASE_URL} from "../../constant/urls";
import axios from "axios";
import {handleMucjCableData} from '../Exchange-View/Exchangecabledetails.util';
// axios call to integrate add cable
export const addCable = async (setMucjLoader,formData, setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg, setOpenCreateModal, params,setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows,url2) => {
    try{
      setMucjLoader(true);
      const cableData = {
        sau: formData.sau,
        exchange: formData.exchange,
        cable: formData.cable,
        cable_weight: formData.cable_weight,
        cable_length: formData.cable_length,
        cable_gauge: formData.cable_gauge,
        logged_user: JSON.parse(localStorage.getItem("USER_EIN")),
        first_name: JSON.parse(localStorage.getItem("FIRST_NAME")),
        last_name: JSON.parse(localStorage.getItem("LAST_NAME")),
        email_id: JSON.parse(localStorage.getItem("EMAIL_ID")),
        }

      const response = await axios.post(
        `${BASE_URL}/${ACR}/create_mucj_cable`, 
        cableData, 
        {
          headers: {
            'Content-Type': 'application/json',
          },
          params: params,  
        }
      );
     
      if (response.data.Status_code === 200 && response.data.status.toLowerCase() === "success") {
        setSuccessSnackMsg(response.data.MESSAGE); 
        setSuccessAlertOpen(true)
        setOpenCreateModal(false)
        handleMucjCableData(params,url2,setMUCJTableData,viewjobid,setSelectedMUCJRows,setLoading,setSnackMsg,setAlertOpen); // Calling the GET API function here
        setMucjLoader(false);
      }
        else if(response.data.Status_code === 200 && response.data.status.toLowerCase() === "fail") {
        setSnackMsg(response.data.MESSAGE); 
        setAlertOpen(true);
        setMucjLoader(false);
      }
    } catch (error) {    
          setSnackMsg("Something went wrong!.Please try again!");
          setAlertOpen(true);
          setMucjLoader(false);
    }
  };